import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import ConfirmLocationChargeSkeleton from '../../ConfirmLocationChargeSkeleton';
import * as MySound from '../../MySound';

export class RF_AdhocTransfer extends Component {

    static displayName = RF_AdhocTransfer.name;


    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            loading: false,
            fromLocationBarcode: "",
            namecode: "",
            createdDocket: 0,
            hasFromLocationLoaded: false,
            displayConfirmChargePrompt: false,
            chargesToBeConfirmed: [
                "STANDARD PALLET",
                "TWO PALLET",
                "THREE PALLET",
                "FOUR PALLET",
                "SIX PALLET",
                "EIGHT PALLET"],
            fromLocationId: 0,
            locationValidated: false,
            selectedStatus: "",
            selectedStatusId: "0",
            selectedChargeType: "",
            selectedChargeTypeId: "0",
            locationData: "",
            locationCharge: "",

            isInventoryAvailableOnTransfer: false,
            inventoriesInTransfer: [],
            enableCompleteButton: false,
            selectedProductCode: "",
            transferCreatedBy: "",
            transferUpdatedBy: "",
            selectedAction: "Pick",
            scanLocationLabel: "Scan Pick Location",
            clientName:""
         
        }
    }

    componentDidMount() {
        this.setState({ 
            chargesToBeConfirmed: [
                "STANDARD PALLET",
                "TWO PALLET",
                "THREE PALLET",
                "FOUR PALLET",
                "SIX PALLET",
                "EIGHT PALLET"]
        });
        if (MyGlobal.rf_transfer) {
            var rf_transfersettings = JSON.parse(MyGlobal.rf_transfer);
            if (rf_transfersettings) {
                this.setState({
                    createdDocket: rf_transfersettings.createdDocket,
                    namecode: rf_transfersettings.namecode,
                    inventoriesInTransfer: rf_transfersettings.inventoriesInTransfer,
                    isInventoryAvailableOnTransfer: rf_transfersettings.isInventoryAvailableOnTransfer,
                    transferCreatedBy: rf_transfersettings.transferCreatedBy,
                    transferUpdatedBy: rf_transfersettings.transferUpdatedBy,
                    selectedAction: rf_transfersettings.selectedAction || "Pick", 
                    scanLocationLabel: rf_transfersettings.selectedAction === "Put" ? "Scan Put Location" : "Scan Pick Location",
                    clientName: rf_transfersettings.clientName
                });
            }
        }
        
    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    prefixBarcodeSegmentWithZero(barCodeSegment) {
        if (barCodeSegment.length == 1) {
            barCodeSegment = "0" + barCodeSegment;
        }
        return barCodeSegment;
    }
    validateLocation() {
        if (this.state.fromLocationBarcode == "") {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Enter a valid Location" });
            return;
        }

        this.state.fromLocationBarcode = this.state.fromLocationBarcode.trim();
        this.getLocationStatus(this.state.fromLocationBarcode);      
    }

    async getLocationStatus(locationBarcode) {

        var warehouseID = MyGlobal.warehouse;
        var url = `api/Tote/GetLocationStatusByBarcode?warehouseID=${warehouseID}&barcode=${locationBarcode}`;
        const response = await fetch(url, {
        });
        const data = await response.json();

        if (data != null) {
            if (data.length > 0) {
                let charge = "";
                let locId = 0;
                for (var value of data) {

                    charge = value.Charge;
                    locId = value.LOC_ID;
                }
                this.state.locationData = data;
                this.state.locationCharge = charge;

                this.setState({ alertMessage: "", locationValidated: true, selectedChargeType: charge, fromLocationId: locId });
                
                const matchingChargeToBeConfirmed = this.state.chargesToBeConfirmed.find((element) => {
                    return element === charge;
                });
                if (matchingChargeToBeConfirmed && this.state.selectedAction === "Put") {

                    this.setState({ displayConfirmChargePrompt: true });
                } else {
                    this.setState({ displayConfirmChargePrompt: false });
                }
                this.setRF_TransferGlobalVariables();
                MySound.play(MySound.Sound.next);

                if (this.state.selectedAction === "Pick") {
                    this.goto('RF_Pick');
                }
                else {
                    this.goto('RF_Put');
                }
                

            } else {
                MySound.play(MySound.Sound.stop);
                this.setState({ alertMessage: "Location not found!!" });
                return;
            }
        }
        else {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Location not found!!" });
            return;
        }
    }
   
   
    setRF_TransferGlobalVariables() {
        MyGlobal.rf_transfer = JSON.stringify({
            createdDocket: this.state.createdDocket,
            namecode: this.state.namecode,
            inventoriesInTransfer: this.state.inventoriesInTransfer,
            isInventoryAvailableOnTransfer: this.state.isInventoryAvailableOnTransfer,
            transferCreatedBy: this.state.transferCreatedBy,
            transferUpdatedBy: this.state.transferUpdatedBy,
            selectedAction: this.state.selectedAction,
            fromLocationId: this.state.fromLocationId,
            fromLocationBarcode: this.state.fromLocationBarcode,
            locationData: this.state.locationData,
            displayConfirmChargePrompt: this.state.displayConfirmChargePrompt,
            clientName: this.state.clientName

        });
    }

    viewStockOnHand(selectedProductCode) {
        this.state.selectedProductCode = selectedProductCode;
        this.goto('RF_StockOnHand');
    }

    navigateBack() {
        if (this.state.createdDocket > 0) {
            this.goto('RF_SelectAction');
        }
        else {
            this.goto('../Transfer');
        }
        
    }

    renderInventoryContentsInTransfer() {

        return (
            <table className='table table-striped' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Code</th>
                        <th>Barcode</th>
                        <th>Description</th>
                        <th>Units</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.inventoriesInTransfer.map((row, index) =>
                        <tr key={index}>
                            <td>{row.productCode}</td>
                            <td>{row.barcode}</td>
                            <td>{row.productDescription}</td>
                            <td>{row.units}</td>
                            <td> <button type="button" className="btn btn-success col-12" onClick={() => { this.viewStockOnHand(row.productCode); }}  >SOH</button></td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }
    render() {
        

        const handleFromLocationKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateLocation();
            }
        };

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";
       
        let inventoryContentsInTransfer = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderInventoryContentsInTransfer();

        return (
            <div>
                <Container>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.navigateBack(); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><h4>Product Transfers</h4></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><b> {this.state.transferCreatedBy} </b></Col>
                        <Col><b> {this.state.transferUpdatedBy} </b></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={6}>
                            <label>Client : {this.state.clientName}</label>
                        </Col>
                        <Col xs={6}>
                            <label>Docket : {this.state.createdDocket}</label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><label>{this.state.scanLocationLabel} :</label></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <input ref="transferFromLocationInput" className="form-control" placeholder="Enter Location Barcode"
                                value={this.state.fromLocationBarcode}
                                onChange={(e) => {
                                    this.setState({ fromLocationBarcode: e.target.value });
                                }} onKeyPress={handleFromLocationKeypress} ></input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-success col-12" onClick={() => { this.validateLocation(); }}  >Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}> <h5> Inventories In Transfer </h5></Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {inventoryContentsInTransfer}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

   
}